export default "__VITE_ASSET__CGWhM1OB__"